import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api, { getErrorMessage } from '../../services/api';

/**
 * Despacho que lleva un expediente judicial (solo admin; docs/partners-plan.md,
 * D3). Ofrece solo los despachos que tienen habilitado al cliente del
 * expediente; el backend lo vuelve a validar.
 */
function PartnerAssignment({ expedient, onChange }) {
  const [partners, setPartners] = useState([]);
  const [saving, setSaving] = useState(false);
  const companyId = expedient?.user_id?._id || expedient?.user_id;

  useEffect(() => {
    if (!companyId) return;
    api
      .get('/partners', { params: { company_id: companyId } })
      .then(({ data }) => setPartners(data.data || []))
      .catch(err => toast.error(getErrorMessage(err)));
  }, [companyId]);

  const handleChange = async e => {
    const partnerId = e.target.value || null;
    setSaving(true);
    try {
      const { data } = await api.put(`/partners/expedients/${expedient._id}`, { partner_id: partnerId });
      onChange(data.data.partner_id);
      toast.success(partnerId ? 'Despacho asignado' : 'Despacho quitado');
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h2 className='text-sm font-medium text-gray-500'>Despacho</h2>
      <select
        className='mt-1 rounded-lg border-gray-300 text-sm focus:ring-blue-500 focus:border-blue-500'
        value={expedient.partner_id || ''}
        onChange={handleChange}
        disabled={saving}
      >
        <option value=''>Sin despacho (no lo ve nadie de fuera)</option>
        {partners.map(p => (
          <option key={p._id} value={p._id}>
            {[p.username, p.userlastname].filter(Boolean).join(' ') || p.usermail}
          </option>
        ))}
      </select>
      {partners.length === 0 && (
        <p className='mt-1 text-xs text-gray-500'>Ningún despacho tiene habilitado a este cliente.</p>
      )}
    </div>
  );
}

export default PartnerAssignment;
